import React from "react";

const ChatUs = ({ category }) => {
  return (
    <div className="col-md-4 my-3">
      <div className="card h-100 no-border">
        <div className="w-100 text-center icon">
          <img className="p-2 chat-img" src={category.image} />
        </div>
        <div className="card-body text-center pb-0 main-countainer">
          <h4 className="font-weight-bold main-title ">{category.title}</h4>
          <h6 className="sub-title">Retail Store/Corporate</h6>
          <p className="font-weight-normal px-md-2">877-723-3929</p>
          <h6 className="sub-title"> Grocery Delivery & Pickup</h6>
          <p className="font-weight-normal px-md-2">877-505-4040</p>
          <h6 className="sub-title">Accessibility Support</h6>
          <p className="font-weight-normal px-md-2">877-635-4833</p>
        </div>
      </div>
    </div>
  );
};

export default ChatUs;
